export const cookieMgr = {
	get(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return false;
	},

	set(cname, cvalue, exdays) {
		var d = new Date();

		var domain = window.location.hostname;
		var domainArr = domain.split('.');

		domain = domainArr[domainArr.length - 2] +'.'+ domainArr[domainArr.length - 1];


		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

		var cookie = [
			cname + '=' + cvalue,
			'domain=.' + domain,
			'expires=' + d.toUTCString(),
			'path=/'
		];
		document.cookie = cookie.join(';');
	}

};

export function preCacheImages(paths) {
	$.each(paths, function(){
		var img = new Image();
		img.src = this;
	});
}

export function sortObject(obj, initial = {}) {
	Object.keys(obj).sort().forEach(v => initial[v] = obj[v]);

	return initial;
}

export function groupBy($items, element) {
	let grouped = {};

	$items.each(function() {
		const grouping = this.querySelector(element).innerText.charAt(0);

		if (typeof grouped[grouping] === 'undefined') {
			grouped[grouping] = [];
		}

		grouped[grouping].push(this);
	});

	return grouped;
}

export function setPage(page) {
	if (page === '') return

	const splited = location.pathname.split('/')

	switch(splited.length) {
		case 4:
			splited.splice(3, 0, page)
			break
		case 5:
			splited[3] = page
			break
	}

	location.replace(splited.join('/'))
}



// WEBPACK FOOTER //
// ./src/desktop/scripts/utils.js